module.exports = __webpack_public_path__ + "img/gala-bg.892d191a.png";